<template>
  <fts-design-modal
    class="fts-api-schema-modal"
    @closed="reset"
    ref="ftsAPISchemaModal"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <fts-moji
          :emoji="formData.item.emoji"
          class="design-modal-header-emoji"
          v-if="formData.item && formData.item.emoji"
        />
        <div
          class="design-modal-header-name"
          :style="titleStyle"
        >
          {{formData.item && formData.item.name || 'Inistate API'}}
        </div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">API</span>
      <span class="design-modal-header-description">documentation</span>
    </template>
    <!-- body -->
    <template #body>
      <!-- helper -->
      <div class="comfort-form-design fts-form-group schema-helper">
        <div>Here are resouces to help you get started to using Inistate API:</div>
        <div class="schema-helper-list">
          <div>Learn how to use <a :href="communityURL" target="_blank" class="fts-link-primary">Inistate API</a>.</div>
          <div>Get <a href="https://app.swaggerhub.com/apis/Inistate/InistateAPI/1.0.0" target="blank" class="fts-link-primary">Inistate API</a> documentation.</div>
          <div>Get your <a class="fts-link-primary" @click.prevent="openUserProfileModal">API Key</a>.</div>
        </div>
      </div>
      <!-- activity (standard activity default) -->
      <fts-form-element
        :form-data="formData"
        :item="{
          'displayName': 'Activity',
          'fieldName': 'activityId',
          'type': 27
        }"
        comfort-design
        ref="form-standard-activity-default-id"
        v-if="isStandardActivityDefault"
      >
        <fts-select
          slot="formElement"
          slot-scope="{ formData, item }"
          :form-data="formData"
          :item="item"
          :clearable="false"
          :options="standardActivityDefaultOptions"
          @input="onInputStandardActivityDefaultId"
          comfort-design
        />
      </fts-form-element>
      <!-- entry id -->
      <fts-form-element
        :form-data="formData"
        :item="{
          'fieldName': 'entry',
          'connectionId': formData.moduleId,
          'type': 7
        }"
        comfort-design
        ref="form-entry-id"
        v-if="formData.type === 'form' && formData.activityId !== 'create'"
      >
        <fts-dropdown
          slot="formElement"
          slot-scope="{ formData, item }"
          :form-data="formData"
          :item="item"
          :module-design="formData.moduleId && formData.moduleId.toString()"
          comfort-design
        />
      </fts-form-element>

      <div class="schema-container">
        <div class="comfort-form-design fts-form-group">
          <!-- request -->
          <div class="schema-wrapper">
            <label class="schema-label">Request URL:</label> {{request.url}}
          </div>
          <div class="schema-wrapper">
            <label class="schema-label">Request Method:</label> {{request.method}}
          </div>
          <fts-json-pretty :data="request.parameters" />
        </div>
        <!-- response -->
        <div class="schema-wrapper" v-if="formData.information">
          <label class="schema-label">References</label>
          <div>
            <label>Information:</label>
            <fts-json-pretty :data="formData.information" default-collapse />
          </div>
        </div>
      </div>
      <!-- user profile -->
      <fts-user-profile ref="ftsUserProfile" />
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <fts-btn text text-transform-init @click="close">
        Close
      </fts-btn>
      <fts-btn
        color="primary"
        outline
        text-transform-init
        @click="copyCurl"
      >
        <template v-if="copied">
          <font-awesome-icon :icon="['fas', 'check']" />
          Copied
        </template>
        <template v-else>
          <font-awesome-icon :icon="['far', 'clone']" />
          Copy as cURL
        </template>
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import commons from '../commons/commons';
import formDesign from '../commons/formDesign';
import webAppConfig from '../commons/webApp.config';

import { authorizationStore } from '../store/authorizationStore';

import FTSDesignModal from "./FTSDesignModal";
import FTSJsonPretty from "./FTSJsonPretty";
import FTSBtn from "../elements/FTSBtn";
import FTSMoji from '../elements/FTSMoji';
import FTSDropdown from '../elements/FTSDropdown';
import FTSFormElement from "../elements/FTSFormElement";
import FTSSelect from "../elements/FTSSelect";
import FTSUserProfile from "../elements/FTSUserProfile";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-json-pretty": FTSJsonPretty,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMoji,
    "fts-dropdown": FTSDropdown,
    "fts-form-element": FTSFormElement,
    "fts-select": FTSSelect,
    "fts-user-profile": FTSUserProfile
  },
  data: () => ({
    communityURL: `${commons.communityURL}/t/how-to-use-inistate-api/437`,
    formData: {},
    canvas: {},
    isStandardActivityDefault: false,
    standardActivityDefaultOptions: [
      { id: 'create', name: 'Create' },
      { id: 'edit', name: 'Edit' },
      { id: 'quickView', name: 'Quick View' },
      { id: 'view', name: 'View' },
    ],
    copied: false,
    copyTimeout: null
  }),
  methods: {
    /**
     * 
     * @param {Object} payload 
     * @param {string} payload.type - listing, form
     * @param {string|number} payload.workspaceId
     * @param {string|number} payload.moduleId
     * @param {string|number} payload.listingId
     * @param {string} payload.activityId
     * @param {Array} payload.information 
     * @param {Object} payload.item
     * @param {Object} canvas
     */
    show(payload, canvas) {
      this.formData = _.cloneDeep(payload);
      this.canvas = _.cloneDeep(canvas);

      if (this.formData.type === 'form') {
        if (this.formData.activityId === 'createEditView') {
          this.isStandardActivityDefault = true;
          this.$set(this.formData, 'activityId', this.standardActivityDefaultOptions[0].id);
          this.onInputStandardActivityDefaultId();
        } else {
          this.$set(
            this.formData,
            'schema',
            this.formData.activityId === 'view' || this.formData.activityId === 'quickView' ? 'form' : 'form-activity'
          );
          this.setFormInformation(this.formData.information);
        }
      } else {
        this.setFormInformation(this.formData.information);
      }

      if (this.formData.moduleId) {
        this.formData.moduleId = this.formData.moduleId.toString();
      }

      this.$refs.ftsAPISchemaModal.show();
    },
    close() {
      this.$refs.ftsAPISchemaModal.close();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    setFormInformation(information) {
      const getInformationTypeName = (type) => {
        const res = commons.informationTypes.find((x) => x.id === type);
        return res && res.type;
      }
      const reduceInformation = (information) =>
        information.reduce((accumulator, x) => {
          accumulator[`//${x.fieldName}_comment`] = `// ${x.displayName} { ${getInformationTypeName(x.type)} }`;
          if (x.type == 1) {
            accumulator[x.fieldName] = "boolean";
          } else if (x.type == 2) {
            accumulator[x.fieldName] = "integer";
          } else if (x.type == 3 || x.type === 4) {
            accumulator[x.fieldName] = "number";
          } else if (x.type == 5 || x.type == 6) {
            accumulator[x.fieldName] = "datetime";
          } else if (x.type == 7) {
            accumulator[x.fieldName] = "string";
            accumulator[`${x.fieldName}Id`] = "string | integer";
          } else if (x.type == 9) {
            accumulator[x.fieldName] = {
              "lat": "number",
              "lng": "number",
              "placeName": "string"
            };
          } else if (x.type == 10 || x.type == 12 || x.type == 29) {
            accumulator[x.fieldName] = {
              "name": "string",
              "path": "string"
            };
          } else if (x.type == 11 || x.type == 13) {
            accumulator[x.fieldName] = [{
              "name": "string",
              "path": "string"
            }];
          } else if (x.type == 14 || x.type == 15) {
            accumulator[x.fieldName] = [reduceInformation(x.fields)];
          } else if (x.type == 20) {
            accumulator[x.fieldName] = "string";
            accumulator[`${x.fieldName}Id`] = "string | integer";
            accumulator[`${x.fieldName}Username`] = "string";
          } else {
            accumulator[x.fieldName] = "string";
          }
          return accumulator;
        }, {});
      
      if (Array.isArray(information) && information.length) {
        this.$set(this.formData, "informationRaw", [...information]);
        this.$set(this.formData, "information", reduceInformation(information))
      } else {
        this.$set(this.formData, "informationRaw", null);
        this.$set(this.formData, "information", null);
      }
    },
    onInputStandardActivityDefaultId() {
      this.setFormInformation(formDesign.getActivityFormInformation(this.canvas, this.formData.activityId, 'standardActivity'));
      this.$set(
        this.formData,
        'schema',
        this.formData.activityId === 'view' || this.formData.activityId === 'quickView' ? 'form' : 'form-activity'
      );
    },
    copyCurl() {
      const resetTimeout = () => {
        clearTimeout(this.copyTimeout);
        this.copyTimeout = null;
      }

      try {
        let body = {};
        if (this.formData.type === 'form') {
          if (this.formData.schema === 'form-activity') {
            const reduceInformation = (information) =>
              information.reduce((accumulator, x) => {
                if (x.type == 7) {
                  accumulator[x.fieldName] = null;
                  accumulator[`${x.fieldName}Id`] = null;
                } else if (x.type == 9) {
                  accumulator[x.fieldName] = {
                    "lat": null,
                    "lng": null,
                    "placeName": null
                  };
                } else if (x.type == 10 || x.type == 12 || x.type == 29) {
                  accumulator[x.fieldName] = {
                    "name": null,
                    "path": null
                  };
                } else if (x.type == 11 || x.type == 13) {
                  accumulator[x.fieldName] = [{
                    "name": null,
                    "path": null
                  }];
                } else if (x.type == 14 || x.type == 15) {
                  accumulator[x.fieldName] = [reduceInformation(x.fields)];
                } else if (x.type == 20) {
                  accumulator[x.fieldName] = null;
                  accumulator[`${x.fieldName}Id`] = null;
                  accumulator[`${x.fieldName}Username`] = null;
                } else {
                  accumulator[x.fieldName] = null;
                }
                return accumulator;
              }, {});

            body = {
              ...this.request.parameters.body,
              'payload': this.formData.informationRaw ? reduceInformation(this.formData.informationRaw) : {}
            };
          } else {
            body = {...this.request.parameters.body};
          }
        } else {
          body = {...this.request.parameters.body};
        }

        const el = document.createElement('textarea');
        el.value = `
          curl '${this.request.url}' \
          -H 'Authorization: ${this.request.parameters.header.Authorization}' \
          -H 'Content-Type: application/json' \
          -H 'tz: ${Intl.DateTimeFormat().resolvedOptions().timeZone}' \
          -H 'wsId: ${this.request.parameters.header.wsId}' \
          --data-raw '${JSON.stringify(body)}' \
        `;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        this.copyTimeout && resetTimeout();
        this.copied = true;
        this.copyTimeout = setTimeout(() => {
          this.copied = false;
          resetTimeout();
        }, 2000);
      } catch(err) { console.warn(err); }
    },
    openUserProfileModal() {
      this.$refs.ftsUserProfile.show({ "section": "integration" });
    }
  },
  computed: {
    apiKey() {
      return authorizationStore.getters.userProfile && authorizationStore.getters.userProfile.apiKey;
    },
    titleStyle() {
      if (this.formData.item && this.formData.item.color) {
        return {
          "color": this.formData.item.color,
        }
      }
    },
    request() {
      const apiKey = `fsk ${this.apiKey || '{ API Key }'}`;
      if (this.formData.schema === 'form') {
        return {
          'url': `${webAppConfig.baseURL}/api/activity/form`,
          'method': 'POST',
          'parameters': {
            'header': {
              'wsId': this.formData.workspaceId,
              'Authorization': apiKey
            },
            'body': {
              'moduleId': this.formData.moduleId,
              'activityId': this.formData.activityId,
              'entryId': this.formData.entryId,
              'locusId': this.formData.entryId
            }
          }
        }
      } else if (this.formData.schema === 'form-activity') {
        return {
          'url': `${webAppConfig.baseURL}/api/activity`,
          'method': 'POST',
          'parameters': {
            'header': {
              'wsId': this.formData.workspaceId,
              'Authorization': apiKey
            },
            'body': this.formData.activityId === 'create' ?
              {
                'moduleId': this.formData.moduleId,
                'activityId': this.formData.activityId,
                'payload': this.formData.information || {}
              } : 
              {
                'moduleId': this.formData.moduleId,
                'activityId': this.formData.activityId,
                'entryId': this.formData.entryId,
                'payload': this.formData.information || {}
              }
          }
        }
      } else if (this.formData.type === 'listing') {
        return {
          'url': `${webAppConfig.baseURL}/api/workspace/list`,
          'method': 'POST',
          'parameters': {
            'header': {
              'wsId': this.formData.workspaceId,
              'Authorization': apiKey
            },
            'body': {
              'moduleId': this.formData.moduleId,
              'listingId': this.formData.listingId,
              'withHeader': true,
              'currentPage': 0,
              'pageSize': 20
            }
          }
        }
      } else if (this.formData.type === 'logicService') {
        return {
          'url': `${webAppConfig.baseURL}/api/activity/logicservice`,
          'method': 'POST',
          'parameters': {
            'header': {
              'wsId': this.formData.workspaceId,
              'Authorization': apiKey
            },
            'body': {
              'moduleId': this.formData.moduleId,
              'logic': this.formData.item.name,
              'payload': {

              }
            }
          }
        }
      }
      return {};
    }
  }
}
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;

.fts-api-schema-modal {
  .schema-helper {
    font-size: $font-size;
    line-height: $line-height;
    .schema-helper-list {
      padding-left: 1.5rem;
      > div {
        display: list-item;
      }
    }
  }
  .schema-container {
    font-size: $font-size;
    line-height: $line-height;
    color: var(--fts-text);
  }
  .schema-wrapper {
    margin-bottom: 0.5rem;
  }
  .schema-label {
    color: var(--fts-default);
  }
}
</style>